import React from "react"
import "twin.macro"
import { ReactComponent as SpinnerImage } from "../../assets/icons/spinner.svg"

export const Loading = () => (
  <div tw="animate-spin h-40 w-full flex items-center justify-center">
    <SpinnerImage width={80} height={80} title="Spinner" />
  </div>
)
